export enum DiscountMode {
  AMOUNT = "amount",
  PERCENT = "percent",
}
